import { Video, VideoCloseButton, VideoContainer } from './integration.styles';
import React from 'react';
import { IIntegration } from './interfaces';

export const Integration = React.forwardRef(
  ({ isFullscreen, handleClose }: IIntegration, ref) => {
    return (
      <VideoContainer isFullscreen={isFullscreen}>
        <Video
          ref={ref as any}
          loop
          controls={isFullscreen}
          isFullscreen={isFullscreen}
        >
          <source src={`/videos/integracja.mp4`} type="video/mp4" />
        </Video>
        {isFullscreen && <VideoCloseButton onClick={handleClose} />}
      </VideoContainer>
    );
  }
);
